import { __awaiter } from "tslib";
import EventEmitter from 'eventemitter3';
import { delay } from 'src/global/delay';
import { AbortController } from 'src/global/abort-controller/AbortController';
import { fromBase64 } from 'src/global/base64';
const REQUEST_TIME_MAX = 5000;
export class AuthController {
    constructor({ api, }) {
        this._session = null;
        this._abortController = new AbortController();
        // region events
        this._events = new EventEmitter();
        this.api = api;
        this._unsubscribe = this.api.subscribe({}, (response, error) => {
            // TODO: if has need2fa && need2fa == true
            var _a, _b, _c;
            const accessToken = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.access_token;
            if (!accessToken) {
                return;
            }
            const [paramsBase64, token] = accessToken.split('.');
            const params = JSON.parse(fromBase64(paramsBase64));
            const accessTokenExpiresTime = params.expTime * 1000;
            if (!this._session) {
                this._session = {};
            }
            this._session.accessToken = accessToken;
            const sessionStart = Date.now();
            let sessionEnd = this._session.sessionTime && Math.min(accessTokenExpiresTime, sessionStart + this._session.sessionTime);
            this._session.userId = params.userId;
            this._session.providerId = params.providerId;
            this._session.isNeed2fa = params.isNeed2fa;
            this._session.sessionStart = sessionStart;
            this._session.sessionEnd = sessionEnd;
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem('session', JSON.stringify(this._session));
            }
            try {
                this._events.emit('login');
                this._events.emit('sessionChanged');
            }
            finally {
                this.autoCheckSessionExpired();
            }
        });
        const sessionStr = typeof localStorage !== 'undefined' && localStorage.getItem('session');
        if (sessionStr) {
            this._session = JSON.parse(sessionStr);
            this._events.emit('sessionChanged');
            this.autoCheckSessionExpired();
        }
    }
    on(name, listener) {
        this._events.on(name, listener);
        return () => {
            this._events.off(name, listener);
        };
    }
    // endregion
    // region autoCheckSessionExpired
    autoCheckSessionExpired() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._session) {
                return;
            }
            while (this._session && this._session.sessionEnd) {
                const now = Date.now();
                if (now < this._session.sessionEnd) {
                    yield delay(Math.min(2 << 31, this._session.sessionEnd - now), this._abortController.signal);
                    continue;
                }
                this.logout();
            }
        });
    }
    // endregion
    _newSession({ sessionTime, }) {
        this.logout();
        this._session = {
            sessionTime,
        };
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('session', JSON.stringify(this._session));
        }
        this._events.emit('sessionChanged');
        return this._session;
    }
    // region login
    login({ username, password, sessionTime, }) {
        return __awaiter(this, void 0, void 0, function* () {
            this._newSession({
                sessionTime,
            });
            yield this.api.request({
                data: {
                    agent: 'auth',
                    auth: { type: 'webSite' },
                    lang: 'en',
                    method: 'auth_login',
                    params: {
                        username,
                        password,
                    },
                },
            });
        });
    }
    // endregion
    // region logout
    logout() {
        if (typeof localStorage !== 'undefined') {
            localStorage.removeItem('session');
        }
        if (this._session) {
            if (this._session.accessToken) {
                this._session = null;
                this._events.emit('logout');
            }
            else {
                this._session = null;
            }
            this._events.emit('sessionChanged');
        }
    }
    // endregion
    get session() {
        return this._session;
    }
    get isLoggedIn() {
        var _a;
        return !!((_a = this._session) === null || _a === void 0 ? void 0 : _a.accessToken);
    }
    destroy() {
        this._abortController.abort();
        this.logout();
        if (this._unsubscribe) {
            this._unsubscribe();
            this._unsubscribe = null;
        }
    }
}
